module.exports = {
    templates: {
        all: 'All',
        add: 'Add',
        loadTip: {
            fail: 'Failed to load template data',
            permission: 'You do not have permission to view template data'
        },
        addTip: {
            success: 'Add template successfully',
            exist: 'The template already exist',
            fail: 'Adding the template failed',
            permission: 'You do not have permission to add template'
        },
        delTip: {
            msg: 'Are you sure you want to delete {demoName}? The template that binds the ESL of the current template after deletion will be deleted',
            success: 'Delete template successfully',
            exist: 'The deleted template does not exist or has been deleted',
            fail: 'Deleting the template failed',
            permission: 'You don not have permission to delete the template'
        },
        copyTip: {
            success: 'Template copied successfully',
            exist: 'Template name already exsits',
            fail:'Template copy failed',
            permission: 'You do not have permission to copy templates'
        },
        find: 'Search for template name',
        findSize: 'Search for size',
        findColor: 'Search for color',
        addTitle: 'Add template',
        delTitle: 'Delete template',
        copyTitle: 'Copy template',
        demoName: 'Template name',
        demoNameMsg: 'Please enter template name',
        demoNameFail: 'Failed to get, please re-enter',
        screenSize: 'Display size',
        sizeSelectMsg: 'All sizes',
        // screenOpt:['1.54"','2.13"','2.9"','4.2"'],
        screenOpt: [1.54, 2.13, 2.66, 2.9, 4.2, 5.83, 7.5, 11.6],
        // screenOpt: [1.54, 2.13, 2.9, 4.2, 5.83, 7.5],
        // screenOpt:[
        //     {
        //         label: 'Please select a size',
        //         value: 0
        //     },{
        //         label: 1.54,
        //         value: 1.54
        //     },{
        //         label: 2.13,
        //         value: 2.13
        //     },{
        //         label: 2.9,
        //         value: 2.9
        //     },{
        //         label: 4.2,
        //         value: 4.2
        //     }
        // ],
        // screenOptDetail:['1.54" (152*152)','2.13" (212*104)','2.9" (296*128)','4.2" (400*300)'],
        demoTypes: [{
            label: 'All',
            value: 0
        }, {
            label: 'Store template',
            value: 2
        }, {
            label: 'System template',
            value: 1
        }],
        screenOptDetail: [{
                inch: 1.54,
                width: 152,
                height: 152,
                id: 1
            },
            {
                inch: 1.54,
                width: 200,
                height: 200,
                id: 2
            },
            // {
            //     inch: 2.13,
            //     width: 212,
            //     height: 104,
            //     id: 3
            // },
            {
                inch: 2.13,
                width: 250,
                height: 122,
                id: 3
            },
            {
                inch: 2.66,
                width: 296,
                height: 152,
                id: 4
            },
            {
                inch: 2.9,
                width: 296,
                height: 128,
                id: 5
            },
            {
                inch: 4.2,
                width: 400,
                height: 300,
                id: 6
            },
            {
                inch: 5.83,
                width: 648,
                height: 480,
                id: 7
            },
            {
                inch: 7.5,
                width: 880,
                height: 528,
                id: 8
            },
            {
                inch: 11.6,
                width: 960,
                height: 640,
                id: 10
            }
        ],
        optionalColor: 'Optional color',
        // optionalColors: [
        //     {
        //         label: 'Black White Red',
        //         value: 'red'
        //     },{
        //         label: 'Black White Yellow',
        //         value: 'yellow'
        //     },{
        //         label: 'Black White',
        //         value: 'black'
        //     }
        // ],
        optionalColors: {
            default: {
                label: 'All colors',
                value: ''
            },
            red: {
                label: 'Black White Red',
                value: 'red'
            },
            yellow: {
                label: 'Black White Yellow',
                value: 'yellow'
            },
            black: {
                label: 'Black White',
                value: 'black'
            }
        },
        optionalColorMsg: 'Please select an optional color',
        screenOrientation: 'Screen orientation',
        optionalOrientation: [{
            label: 'Horizontal',
            value: 0
        }, {
            label: 'Vertical',
            value: 1
        }],
        optionalOrientationMsg: 'Please select the screen orientation',
        cancel: 'Cancel',
        sure: 'OK',
        sampleContent: {
            proNo: '1101',
            name: 'Minew ESL',
            proAbbr: 'ESL',
            brand: 'Minew',
            price: '￥68.00',
            origin: 'Shenzhen, China',
            rating: 'A',
            piece: 'piece',
            specification: '2901',
            supplierName: 'Minew',
            barcodeText: '6666666666666',
            qrcodeText: 'http://minewtech.com',
            barcode: '6666666666666',
            qrcode: "http://minewtech.com"
        },
        samplePrefix: {
            proNo: '编号：',
            name: '品名：',
            proAbbr: '简称：',
            brand: '品牌：',
            price: '',
            origin: '产地：',
            rating: '等级：',
            piece: '单位：',
            specification: '规格：',
            supplierName: '供货商：',
            barcodeText: '',
            qrcodeText: ''
        },
        noData: 'No data',
        submiting: 'Submiting...',
        text: 'text'
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/en/templates.js